import { render } from "./TimeDepositsPage.vue?vue&type=template&id=0415f0cc"
import script from "./TimeDepositsPage.vue?vue&type=script&lang=js"
export * from "./TimeDepositsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__